import { render, staticRenderFns } from "./MediakitPropertySettings.vue?vue&type=template&id=6b19eb25&"
import script from "./MediakitPropertySettings.vue?vue&type=script&lang=js&"
export * from "./MediakitPropertySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports